import React, { useContext, useState } from 'react'
// components
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, Modal } from 'reactstrap';
import { componentsNamesFactoryForTitle, modalNamesFactory, multiTypeDescriptionsMarkDownFactory } from '../../Helper_functions/Languages/LanguageSelector';
import { BsArrowRepeat, BsFillCloudArrowUpFill } from 'react-icons/bs';
import Modal_pop_up from '../Model_pop_up/Modal_pop_up';
import CsvDownloadButton from "react-json-to-csv";
// context
import { LanguageContext } from '../../context/languageContext';
import { LanguageIdContext } from '../../context/languageIdContext';
import MarkdownDownloaderButton from './MarkdownDownloaderButton';
import { getSurveyModel, markdownToHTML, returnSurveyType, returnType } from '../../Helper_functions/Helper_functions';
import { Model } from 'survey-react';
interface CoreButtonGroupProps {
    back_to_start_clicked: () => void;
    back_button_clicked: () => void;
    clearSurvey: () => void;
    Data: any;
    CsvFileName: string;
    survey: Model | null;
}

export const CoreButtonGroup: React.FC<CoreButtonGroupProps> = ({back_to_start_clicked,back_button_clicked,clearSurvey,Data,CsvFileName,survey}) => {
    const {language} = useContext(LanguageContext);
    const {languageId} = useContext(LanguageIdContext);

    const [reset_modal, setReset_modal] = useState(false);
    const [sendSurvey, setSendSurvey] = useState(false);
    const [openFailedModel, setOpenFailedModel] = useState(false);
    const [openSuccessModel, setOpenSuccessModel] = useState(false);
    const [dropDownOpen, setDropDownOpen] = useState(false);
    const [sendingData, setSendingData] = useState(false);
    

        return (
            <div className="core-button-group">
          <ButtonDropdown
            isOpen={dropDownOpen}
            toggle={() => {
              setDropDownOpen((isOpen) => !isOpen);
            }}
          >
            <DropdownToggle color="info" caret>
              {componentsNamesFactoryForTitle(languageId, "Go Back")}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={back_to_start_clicked}>
                {componentsNamesFactoryForTitle(languageId, "Start")}
              </DropdownItem>
              <DropdownItem onClick={back_button_clicked}>
                {componentsNamesFactoryForTitle(languageId, "End")}
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>

          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              setReset_modal(true);
            }}
          >
            <BsArrowRepeat size={17} />{" "}
            <div>{componentsNamesFactoryForTitle(languageId, "Reset")}</div>
          </button>
          {/* <CsvDownloadButton
             data={[getCSVdata(Data.date, Data.data, Data.p1, Data.p2, Data.p3, Data.p4, Data.total)]}
            // data={Data}
            // filename={`mat_facilitator_${org}_${date}`}
            filename={CsvFileName}
            className="btn btn-success"
            delimiter=","
          >
            <BsArrowDown size={17} />{" "}
            {componentsNamesFactoryForTitle(languageId, "Personal Copy")}
          </CsvDownloadButton> */}
          <MarkdownDownloaderButton
          content={dataToContent(Data.date, Data.data, Data.p1, Data.p2, Data.p3, Data.p4, Data.total, languageId,survey)}
          filename='MatFacilitatorResults'
          id={languageId}
          />
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              setSendSurvey(true);
            }}
          >
            <BsFillCloudArrowUpFill size={17} />{" "}
            <div>{componentsNamesFactoryForTitle(languageId, "Send")}</div>
          </button>
          <Modal_pop_up
            title={modalNamesFactory(languageId, "Reset Survey")}
            isOpen={reset_modal}
            body={modalNamesFactory(languageId, "resetInstructions")}
            buttonTitle={modalNamesFactory(languageId, "Reset/End Survey")}
            bnt_cancel_onclick={() => {
              setReset_modal(false);
            }}
            bnt_confirm_onclick={() => {
              clearSurvey();
              setReset_modal(false);
            }}
            buttonColor={"warning"}
          />
          <Modal hidden={false} />
          <Modal_pop_up
            title={modalNamesFactory(languageId, "Send Survey")}
            isOpen={sendSurvey}
            body={modalNamesFactory(languageId, "submitInstructions")}
            buttonTitle={modalNamesFactory(languageId, "Send Survey")}
            disable={sendingData}
            bnt_cancel_onclick={() => {
              setSendSurvey(false);
            }}
            bnt_confirm_onclick={async () => {
              setSendingData(true);
              let success = await submit_data_to_gs(
                Data.date, Data.data, Data.p1, Data.p2, Data.p3, Data.p4, Data.total
              );

              if (success) {
                setOpenSuccessModel(true);
              } else {
                setOpenFailedModel(true);
              }
              setSendSurvey(false);
              setSendingData(false);
            }}
            buttonColor={"success"}
          />
          <Modal_pop_up
            title={modalNamesFactory(languageId, "Failed to send")}
            isOpen={openFailedModel}
            body={modalNamesFactory(languageId, "failedInstructions")}
            buttonTitle={modalNamesFactory(languageId, "ok")}
            bnt_confirm_onclick={() => {
              setOpenFailedModel(false);
            }}
            buttonColor={"danger"}
          />
          <Modal_pop_up
            title={modalNamesFactory(languageId, "Success")}
            isOpen={openSuccessModel}
            body={modalNamesFactory(languageId, "successInstructions")}
            buttonTitle={modalNamesFactory(languageId, "ok")}
            bnt_confirm_onclick={() => {
              setOpenSuccessModel(false);
            }}
            buttonColor={"success"}
          />
        </div>
        )
}


const getCSVdata = (
    date: any,
    data: any,
    p1: number,
    p2: number,
    p3: number,
    p4: number,
    total: number
  ) => {
    //  copy survey data, do not use (=) it copys ref not items
    let output: any = {};
    let count = 1;
    output["date"] = date;
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // They did not want checkboxes
  
        // if (key.includes("chbox_1")) {
        //   data[key].forEach((element:any)=> {
        //   output[`${key}_${count}`] = element
        //   count++;
        //  });
        //  //reset count
        //  count = 1;
        // }
        // if(key.includes("chbox_2")){
  
        //   data[key].forEach((element:any)=> {
        //     output[`${key}_${count}`] = element
        //     count++;
        //    });
        //    //reset count
        //    count = 1;
  
        // }
        if (
          !(
            key.includes("chbox_2") ||
            key.includes("chbox_1") ||
            key.includes("page")
          )
        ) {
          output[key] = data[key];
        }
      }
    }
    output["Limited"] = `${p1} out of ${total}`;
    output["Shifting"] = `${p2} out of ${total}`;
    output["Shifted"] = `${p3} out of ${total}`;
    output["Widespread"] = `${p4} out of ${total}`;
  
    //returns
    return output;
  };
  
  const submit_data_to_gs = async (
    date: any,
    data: any,
    p1: number,
    p2: number,
    p3: number,
    p4: number,
    total: number
  ) => {
    let success = true;
    await fetch((process.env.NODE_ENV==="development"?"http://localhost:8888/.netlify/functions/sendToGoogleSheets":"/.netlify/functions/sendToGoogleSheets"), {
      method: "POST",
      body: JSON.stringify(getCSVdata(date, data, p1, p2, p3, p4, total)),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        "access-control-allow-origin": "*",
      },
    })
      .then((result) => {
        if (!(result.status == 200)) {
          success = false;
        }
      })
      .catch((error) => {
        success = false;
      });
    return success;
  };

const dataToContent = (date: any,
  data: any,
  p1: number,
  p2: number,
  p3: number,
  p4: number,
  total: number,
  languageId: number,
  survey: Model | null
) => {
let limitedMD = multiTypeDescriptionsMarkDownFactory(languageId, "limited");
let shiftingMD = multiTypeDescriptionsMarkDownFactory(languageId, "shifting");
let shiftedMD = multiTypeDescriptionsMarkDownFactory(languageId, "shifted");
let widespreadMD = multiTypeDescriptionsMarkDownFactory(languageId,"widespread");
let local_language = data["local_language"];
let second_language = data["second_language"];
let third_language = data["other_language"];
let type = returnType(p1,p2,p3,p4);
let guidance = "";
let answersToQuestions = "";
if(survey === null){
  let internalSurvey = getSurveyModel(languageId);
  survey = internalSurvey;
}


survey.getAllQuestions().forEach((question) => {
  let value = returnSurveyType(data[question.name]);
  if(value != "unknown"){
    answersToQuestions += `<li>(${value}) - ${question.title}</li>\n`;
  }
});
answersToQuestions = answersToQuestions.replace(/<p>/g, "").replace(/<\/p>/g, "").replace(/<p\/>/g, "");
answersToQuestions = answersToQuestions.replace(/{local_language}/g, local_language).replace(/{second_language}/g, second_language).replace(/{other_language}/, third_language);


console.log(answersToQuestions);


switch (type) {
  case "Limited":
    guidance = limitedMD;
    break;
  case "Shifting":
    guidance = shiftingMD;
    break;
  case "Shifted":
    guidance = shiftedMD;
    break;
  case "Widespread":
    guidance = widespreadMD;
    break;
  default:
    guidance = limitedMD;
    break;
}
answersToQuestions = `<br><br>The answers to the specific questions were:<br>`+`<ul>${answersToQuestions}</ul>`;

let content =
  `<p>This is an assessment of ${data["townName"]}, ${data["radioUrbanRural"]} community in ${data["country"]}. It was assessed as having ${type} type of multilingualism. Language use was considered for ${data["local_language"]}, ${data["second_language"]}, and ${data["other_language"]}.</p>` +
  guidance +
  answersToQuestions;
  
    return markdownToHTML(content);
}



